// extracted by mini-css-extract-plugin
export default {"cell":"DHGXV","value":"I4PzQ","dots":"DFktl","dot":"AeolI","icon":"wz3t_"};